var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99567 1.66663C5.3915 1.66663 1.6665 5.39579 1.6665 9.99996C1.6665 14.6041 5.3915 18.3333 9.99567 18.3333C14.5998 18.3333 18.3332 14.6041 18.3332 9.99996C18.3332 5.39579 14.5998 1.66663 9.99567 1.66663ZM9.99984 16.6666C6.3165 16.6666 3.33317 13.6833 3.33317 9.99996C3.33317 6.31663 6.3165 3.33329 9.99984 3.33329C13.6832 3.33329 16.6665 6.31663 16.6665 9.99996C16.6665 13.6833 13.6832 16.6666 9.99984 16.6666Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4165 5.83337H9.1665V10.8334L13.5373 13.4584L14.1665 12.4334L10.4165 10.2084V5.83337Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.6366d6813dca465d1ae8d4159b9a22e9.svg";
export { ForwardRef as ReactComponent };